// extracted by mini-css-extract-plugin
module.exports = {"rotation":"BrandTemplate_rotation__goMy_"};